import { render, staticRenderFns } from "./add_profissional.vue?vue&type=template&id=60add6d8&"
import script from "./add_profissional.vue?vue&type=script&lang=js&"
export * from "./add_profissional.vue?vue&type=script&lang=js&"
import style0 from "./add_profissional.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports